import { create } from 'zustand';

const useUiStore = create((set, get) => ({
  isLayersPanelOpen: true,
  isFontsPanelOpen: false,
  isProductDataPanelOpen: false,
  isProductPropertiesOpen: false,

  toggleLayersPanel: () =>
    set((s) => ({ isLayersPanelOpen: !s.isLayersPanelOpen })),

  toggleFontsPanel: () =>
    set((s) => ({ isFontsPanelOpen: !s.isFontsPanelOpen })),

  toggleProductDataPanel: () =>
    set((s) => ({ isProductDataPanelOpen: !s.isProductDataPanelOpen })),

  toggleProductPropertiesPanel: () =>
    set((s) => ({ isProductPropertiesOpen: !s.isProductPropertiesOpen })),

  setLayersPanelOpen: (v) => set({ isLayersPanelOpen: v }),
  setFontsPanelOpen: (v) => set({ isFontsPanelOpen: v }),
  setProductDataPanelOpen: (v) => set({ isProductDataPanelOpen: v }),
  setProductPropertiesOpen: (v) => set({ isProductPropertiesOpen: v }),

  closeAllPanels: () =>
    set({
      isLayersPanelOpen: false,
      isFontsPanelOpen: false,
      isProductDataPanelOpen: false,
      isProductPropertiesOpen: false,
    }),

  reset: () =>
    set({
      isLayersPanelOpen: true,
      isFontsPanelOpen: false,
      isProductDataPanelOpen: false,
      isProductPropertiesOpen: false,
    }),
}));

export default useUiStore;
